import useFormFields from '../../hooks/useFormFields'
import Form from '../form/Form'
import OBDValidationButton from './OBDValidationButton'

const PreOBDScreen = () => {
  const { preOBDFields } = useFormFields()
  return (
    <main className="form">
      <div className="form-container">
        <h2 className="form-title">Ingresá los datos del cliente</h2>
        <Form fields={preOBDFields} storeForm="preOBDForm" inputsPosition="floating" />
        <OBDValidationButton label="Continuar" storeForm="preOBDForm" />
      </div>
    </main>
  )
}

export default PreOBDScreen
